import LogoSvg from './logo.svg';

const Logo = () => {
    return (
        <img src={LogoSvg} height='30px' alt='Logo'/>
    );
  };
  export default Logo;